import { ref } from 'vue';
import axios from 'axios';
const updateSingleVehiclePrice = (id, price) => {
    let status = ref("");
    try {
        const loadUpdateSingVehiclePriceRequest = async () => {
            await axios
                .post(axios.defaults.baseUrl + "updateSingleVehiclePrice",
                    {
                        id: id,
                        price: price,
                    },
                    {
                        headers: {
                            Authorization: "Bearer " + localStorage.getItem('auth_token'),
                        },
                    }
                )
                .then((response) => {
                    if(response) {
                        status.value = "success";
                    }
                })
                .catch((error) => {
                    if(error) {
                        // status.value = "error";
                        console.log(error);
                    }
                });
        }
        return { status, loadUpdateSingVehiclePriceRequest };
    } catch (error) {
        if(error) {
            // status.value = "error";
            console.log(error);
        }
    }
}
export default updateSingleVehiclePrice;